export default function isDesktop() {
  return window.innerWidth >= 768;
}
